export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9028.314877c3.jpg";